import type { AvailabilityState } from '@intent/shared';

/**
 * The status line under the founder's name: a green dot, the role, and a
 * state-aware label.
 *
 * The dot stays lit because the assistant is always reachable — a visitor who
 * writes always gets an answer, even with no one at the keyboard. The label is
 * what shifts: "online now" only when the founder is genuinely available to
 * jump in; otherwise a plain "Online" that's honest about the live channel
 * without implying the founder is watching.
 */
export function PresenceLine({
  role,
  availabilityState,
}: {
  role: string;
  availabilityState: AvailabilityState;
}) {
  const status = availabilityState === 'available' ? 'online now' : 'Online';
  // `role` can be absent if an older API build hasn't sent it yet, so it is
  // coerced rather than trimmed directly.
  const parts = [(role ?? '').trim(), status].filter(Boolean);

  return (
    <span className="presence" data-online="true">
      <span className="presence-dot" aria-hidden />
      {parts.join(' · ')}
    </span>
  );
}
